import { types } from 'mobx-state-tree';
import { User } from './User';

const _assessmentUser = types.model({
    reportsToName: types.string
});

export const AssessmentUserViewModel = types.compose('AssessmentUserViewModel', User, _assessmentUser);